import React from 'react';
import TextField from '@material-ui/core/TextField';

function TextFieldComp({
  name,
  error,
  label,
  helpertext = ' ',
  value = '',
  onChange,
  handleEnter,
  inputStyles,
  placeholder,
  blurHandle,
  disabled,
  type,
  multiline,
  required,
  minRows,
  maxRows,
  InputProps,
  compFrom,
  alignRight,
}) {
  return (
    <TextField
      type={type}
      disabled={disabled ? true : false}
      name={name}
      error={error}
      // id="outlined-basic"
      variant='outlined'
      // placeholder={placeholder ? placeholder : ''}
      label={label}
      className={inputStyles}
      helperText={compFrom ? '' : helpertext}
      value={value}
      onChange={onChange}
      size='small'
      InputProps={{
        autoComplete: 'new-off',
        ...InputProps,
      }}
      inputProps={{
        style: { textAlign: alignRight ? 'right' : 'left' },
      }}
      InputLabelProps={{
        style: {
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          width: '100%',
          color: '#9999a2',
        },
      }}
      autoComplete='new-off'
      onKeyDown={handleEnter}
      margin='none'
      onBlur={blurHandle ? blurHandle : () => null}
      multiline={multiline}
      rows={minRows}
      rowsMax={maxRows}
    />
  );
}

export default TextFieldComp;
